import React from "react";
import Popup from "reactjs-popup";
import { CgMoreO } from "react-icons/cg";
import stylesModal from "./modalgallery.module.css";
import { Carousel } from "react-responsive-carousel";
import { AiOutlineClose } from "react-icons/ai";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ModalGallery = ({ userImages, handleDeleteImage, isEditable }) => {
  return (
    <Popup
      trigger={
        <button className={stylesModal.button}>
          <span>
            <CgMoreO />
          </span>
        </button>
      }
      modal
      nested
    >
      {(close) => (
        <div className={stylesModal.modal}>
          <button className={stylesModal.close} onClick={close}>
            <AiOutlineClose />
          </button>
          <Carousel>
            {userImages.map((img) => (
              <div key={img.img_id} className={stylesModal.picDiv}>
                <img src={img.url} alt={`img-${img.img_id}`} />
                {isEditable && (
                  <button
                    className={stylesModal.deleteButton}
                    onClick={() => handleDeleteImage(img.img_id)}
                  >
                    Delete
                  </button>
                )}
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </Popup>
  );
};

export default ModalGallery;
